import { RecursivePartial } from 'types/interfaces';

import { INTERNAL_OPTION } from './constants';

export const isCloudAccountExternal = (
  cloudAccount: RecursivePartial<CloudAccount> | CloudAccount | null
) => {
  if (!cloudAccount) {
    return false;
  }

  if (cloudAccount.ownership === 'internal') {
    return false;
  }

  if (cloudAccount.ownership === 'external') {
    return true;
  }

  return cloudAccount.id !== INTERNAL_OPTION.id;
};
